<template>
<div class="chapter">
<div class="inner_page">
<p class="fmcenter"><a id="page_i">The first law of the historian is that he shall never dare utter an untruth.</a></p><a id="page_i">
<p class="fmcenter">The second is that he shall suppress nothing that is true.</p>
<p class="fmcenter">Moreover, there shall be no suspicion of partiality in his writing, or of malice.</p>
<p class="fmcenter">— Cicero</p>
</a>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// fm.vue?3bd318c8